import { render, staticRenderFns } from "./SettingsTravelServiceAdditionalParametersView.vue?vue&type=template&id=2b66d083&scoped=true&"
import script from "./SettingsTravelServiceAdditionalParametersView.vue?vue&type=script&lang=js&"
export * from "./SettingsTravelServiceAdditionalParametersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66d083",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VDataTable,VIcon,VRow,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b66d083')) {
      api.createRecord('2b66d083', component.options)
    } else {
      api.reload('2b66d083', component.options)
    }
    module.hot.accept("./SettingsTravelServiceAdditionalParametersView.vue?vue&type=template&id=2b66d083&scoped=true&", function () {
      api.rerender('2b66d083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/travel-service/SettingsTravelServiceAdditionalParametersView.vue"
export default component.exports